import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import './RecurringBuyEditConfirmation.scss';

import config from '../../../../config/config';
import ConfirmationSnapshot from '../../ConfirmationSnapshot/ConfirmationSnapshot';
import Button from '../../../Shared/Button/Button';
import CheckMark from '../../../Shared/CheckMark/CheckMark';
import If from '../../../Shared/If/If';
import { isRecurringContribute } from '../../../../utils/transactions-util';
import CollegeBrandingContainer from '../../../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import RecurringContributeEditWhatsNext from '../../WhatsNext/RecurringBuyEdit/RecurringContributeEditWhatsNext';
import RecurringBuyEditWhatsNext from '../../WhatsNext/RecurringBuyEdit/RecurringBuyEditWhatsNext';
import { appendBasePath } from './../../../../utils/nav.utils';

const CONFIRM_PATH_SUFFIX = '/confirm';

export class RecurringBuyConfirmation extends Component {
  componentDidMount() {
    const { dispatchPageLoad } = this.props;
    ReactDOM.findDOMNode(this).scrollIntoView();
    dispatchPageLoad('Confirmation');
  }

  render() {
    const {
      isSalesforceRep,
      customerWebViewEnabled,
      confirmationNumber,
      transactions,
      location: { pathname },
      history,
    } = this.props;
    if (transactions.length === 0 && pathname.endsWith(CONFIRM_PATH_SUFFIX)) {
      history.push(
        pathname.substr(0, pathname.length - CONFIRM_PATH_SUFFIX.length)
      );
    }

    return (
      <CollegeBrandingContainer>
        <div className="recurring-buy-edit-confirmation-page">
          <div className="recurring-buy-edit-confirmation-background-design college-branded-header">
            <span className="recurring-buy-edit-confirmation-background-design-inner" />
          </div>
          <div className="container">
            <div className="recurring-buy-edit-confirmation-container row">
              <div className="col-xs-12 col-sm-7 col-md-8 recurring-buy-edit-confirmation-submit-text">
                <div className="recurring-buy-edit-confirmation-heading">
                  Changes to your automatic buy transaction have been submitted.
                </div>
                <div className="recurring-buy-edit-confirmation-subheading">{`You will receive an email notification of your changes.`}</div>
              </div>
              <div className="col-xs-12 col-sm-5 col-md-4">
                <ConfirmationSnapshot
                  id="confirmation-snapshot"
                  transactions={transactions}
                  successIcon={
                    <CheckMark className="recurring-buy-edit-confirmation-checkmark" />
                  }
                  confirmationNumber={confirmationNumber}
                />
              </div>
            </div>
            <If test={!(!customerWebViewEnabled && isSalesforceRep)}>
              <If test={isRecurringContribute()}>
                <div className="recurring-buy-edit-confirmation-mobile-buttons">
                  <a href={`${config.url}/usis/transactions/automatic`}>
                    <Button buttonType="secondary-ghost">
                      Add or Edit Recurring
                    </Button>
                  </a>
                  <a href={`${config.url}/usis/my-accounts/dashboard`}>
                    <Button buttonType="secondary-ghost">
                      Go to Dashboard
                    </Button>
                  </a>
                </div>
                <RecurringContributeEditWhatsNext />
                <p>2820024</p>
              </If>
              <If test={!isRecurringContribute()}>
                <div className="recurring-buy-edit-confirmation-mobile-buttons">
                  <a href={`${config.url}${appendBasePath('/automatic/buy')}`}>
                    <Button buttonType="secondary-ghost">
                      Submit Another Plan
                    </Button>
                  </a>
                  <a href={`${config.url}/usis/my-accounts/dashboard`}>
                    <Button buttonType="secondary-ghost">View Dashboard</Button>
                  </a>
                </div>
                <RecurringBuyEditWhatsNext />
                <p>2820024</p>
              </If>
            </If>
          </div>
        </div>
      </CollegeBrandingContainer>
    );
  }
}

export default compose(withRouter)(RecurringBuyConfirmation);
